const $ = window.jQuery;
const $window = window.$window || $(window);

const Tabs = {

    init() {
        let $module = $('.Tabs');
        if (!$module.length)
            return;

        $module.each((index, element) => {
            this.each(element);
        });
    },

    each(element) {

        let $item = $(element);

        let $tabs = null;
        let $content = null;
        let $activeTabClasses = '';
        let $inactiveTabClasses = '';

        $item.on('click', '.Tabs__tab', function () {
            let $clickedTab = $(this);
            let clickedIndex = $clickedTab.index();

            // Handle these on first click only.
            $tabs = $tabs || $item.find('.Tabs__tab');
            $content = $content || $item.find('.Tabs__tab-content');
            $activeTabClasses = $activeTabClasses || $item.data('active-tab-classes');
            $inactiveTabClasses = $inactiveTabClasses || $item.data('inactive-tab-classes');

            $content.hide();
            $($content[clickedIndex]).show();

            $tabs.removeClass($activeTabClasses).addClass($inactiveTabClasses);
            $clickedTab.addClass($activeTabClasses);
        });


    }

};

export default Tabs;
